export default __webpack_public_path__ + "static/media/SAS_BG.135477b2.jpg";